import React from 'react';
import { getMeta } from '@/lib/utils';

const customLogoUrl: string | null = getMeta('branding-logo-url');
const companyName: string | null   = getMeta('branding-company-name');
const loginHeightPx: number = (() => {
  const raw = getMeta('branding-logo-login-height') ?? getMeta('branding-logo-max-height');
  if (!raw) return 80;
  const n = parseInt(raw, 10);
  return Number.isFinite(n) && n > 0 ? n : 80;
})();

const LogoHeader: React.FC = () => {
  // When a custom logo is configured, show it with the company name as alt text.
  // When there's no custom logo but a company name is set, show the name as text.
  // Otherwise fall back to the default Univo SVG.
  if (customLogoUrl) {
    return (
      <a href="/" className="flex justify-center">
        <img
          src={customLogoUrl}
          alt={companyName ?? 'Logo'}
          style={{ height: loginHeightPx, width: 'auto', maxWidth: '100%' }}
          className="mb-10 mt-12"
        />
      </a>
    );
  }

  if (companyName?.trim()) {
    return (
      <a href="/" className="flex justify-center mb-10 mt-12">
        <span className="text-2xl font-bold text-white">{companyName}</span>
      </a>
    );
  }

  return (
    <a href="/" className="flex justify-center">
      <img
        src="/static/univo-round-logo.svg"
        alt="Logo"
        style={{ height: loginHeightPx, width: 'auto', maxWidth: '100%' }}
        className="mb-10 mt-12"
      />
    </a>
  );
};

export default LogoHeader;
